import { useState, useEffect } from 'react'
import { io } from 'socket.io-client'

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000'

export function useSocket(session) {
  const [socket, setSocket] = useState(null)

  useEffect(() => {
    const token = session?.access_token || ''
    const newSocket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      auth: { token },
    })

    setSocket(newSocket)

    return () => {
      newSocket.close()
    }
  }, [session?.access_token])

  return { socket }
}
